import { render, staticRenderFns } from "./vue-form.vue?vue&type=template&id=112277df"
import script from "./vue-form.vue?vue&type=script&lang=js"
export * from "./vue-form.vue?vue&type=script&lang=js"
import style0 from "./vue-form.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports